module.exports = __webpack_public_path__ + "img/keytags-findmykit-banner.b92a9e7c.png";